export default __webpack_public_path__ + "static/media/rollbit.863a23aa.svg";